const altTxt = 'No Image';


export {altTxt};